import { projectContainerClassName } from '@website/conf/consts'

export const scrollToTop = () => {
  const editor = document.querySelector(`.${projectContainerClassName}`)
  editor.scrollTop = 0
}
